(function(root,factory){
 const api=factory();
 if(typeof module==='object'&&module.exports){module.exports=api;return;}
 if(root.BFSignupRuntime)return;
 root.BFSignupRuntime=api;
 const boot=()=>{
  const node=root.document.getElementById('bf-signup-runtime-config');
  if(!node||api.instance)return;
  let config;
  try{config=JSON.parse(node.textContent);}catch{return;}
  api.instance=api.createRuntime(root,root.document,config);
  api.instance.start();
 };
 if(root.document.readyState==='loading')root.document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})(typeof window!=='undefined'?window:globalThis,function(){
 'use strict';
 const sdkURL='https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=YsNQrZ';
 const ownedSelector='[role="dialog"][aria-label="Join the flock"]';
 const blockerSelector='#shopify-pc__banner, #shopify-pc__prefs, #shopify-pc__prefs__dialog, #bf-join-modal[open]';
 function normalizeRoute(pathname){
  if(typeof pathname!=='string'||!pathname.startsWith('/')||pathname.startsWith('//'))return null;
  let path;
  try{path=decodeURIComponent(pathname);}catch{return null;}
  if(/[?#\\%\u0000-\u0020\u007f]/.test(path)||path.includes('//')||/(?:^|\/)\.{1,2}(?:\/|$)/.test(path))return null;
  return path.replace(/\/+$/,'')||'/';
 }
 function isRouteAllowed(pathname,locale){
  if(locale!=='en'&&locale!=='nl')return false;
  const normalized=normalizeRoute(pathname);
  if(normalized===null)return false;
  const path=normalized.toLowerCase();
  const first=path.split('/')[1];
  if(locale==='nl'&&first!=='nl')return false;
  if(locale==='en'&&['nl','de','fr'].includes(first))return false;
  const local=path.replace(/^\/(?:en|nl)(?=\/|$)/,'')||'/';
  return !/^\/(?:account|cart|checkouts?|challenge|policies)(?:\/|$)/.test(local)&&!/^\/pages\/(?:contact|support)/.test(local);
 }
 function readConsent(api){
  if(!api||typeof api.currentVisitorConsent!=='function'||typeof api.analyticsProcessingAllowed!=='function'||typeof api.marketingAllowed!=='function')return {allowed:false,reason:'consent-api-unavailable'};
  try{
   const consent=api.currentVisitorConsent();
   if(!consent||consent.analytics!=='yes'||consent.marketing!=='yes')return {allowed:false,reason:'explicit-consent-required'};
   if(api.analyticsProcessingAllowed()!==true||api.marketingAllowed()!==true)return {allowed:false,reason:'processing-not-allowed'};
   return {allowed:true,reason:'allowed'};
  }catch{return {allowed:false,reason:'consent-api-error'};}
 }
 function isVendorRequest(url,method,baseURL){
  const verb=String(method||'GET').toUpperCase();
  if(verb==='GET'||verb==='HEAD')return {blocked:false,subscription:false};
  try{
   const parsed=new URL(String(url),baseURL);
   const host=parsed.hostname.toLowerCase().replace(/\.$/,'');
   const vendor=['klaviyo.com','klaviyomail.com','kmail-lists.com'].some(domain=>host===domain||host.endsWith('.'+domain));
   return {blocked:vendor,subscription:vendor&&/\/(?:subscriptions?|profile-subscription[^/]*)(?:\/|$)/i.test(parsed.pathname)};
  }catch{return {blocked:false,subscription:false};}
 }
 function installReviewFence(win,onBlock){
  const restorers=[];
  const denied=()=>new Error('BF review: external write blocked');
  if(typeof win.fetch!=='function'||typeof win.XMLHttpRequest?.prototype?.open!=='function'||typeof win.XMLHttpRequest?.prototype?.send!=='function'||typeof win.navigator?.sendBeacon!=='function')throw denied();
  const check=(url,method)=>{
   const result=isVendorRequest(url,method,win.location.href);
   if(result.blocked)onBlock(result.subscription);
   return result.blocked;
  };
  function replace(target,key,value){
   const old=target[key];
   target[key]=value;
   if(target[key]!==value)throw denied();
   restorers.push(()=>{if(target[key]===value)target[key]=old;});
   return old;
  }
  try{
   if(typeof win.fetch==='function'){
    const original=win.fetch;
    replace(win,'fetch',function(input,init){
     const url=typeof input==='string'?input:typeof input?.href==='string'?input.href:input?.url;
     const method=init?.method||input?.method||'GET';
     if(check(url,method))return Promise.reject(denied());
     return original.apply(this,arguments);
    });
   }
   const proto=win.XMLHttpRequest?.prototype;
   if(proto&&typeof proto.open==='function'&&typeof proto.send==='function'){
    const states=new WeakMap(),open=proto.open,send=proto.send;
    replace(proto,'open',function(method,url){states.set(this,isVendorRequest(url,method,win.location.href));return open.apply(this,arguments);});
    replace(proto,'send',function(){
     const result=states.get(this);
     if(result?.blocked){onBlock(result.subscription);throw denied();}
     return send.apply(this,arguments);
    });
   }
   if(win.navigator&&typeof win.navigator.sendBeacon==='function'){
    const original=win.navigator.sendBeacon;
    replace(win.navigator,'sendBeacon',function(url){if(check(url,'POST'))return false;return original.apply(this,arguments);});
   }
  }catch(error){restorers.reverse().forEach(restore=>restore());throw error;}
  return ()=>restorers.reverse().forEach(restore=>restore());
 }
 function isElementVisible(win,element){
  if(!element||!element.getClientRects||element.getClientRects().length===0)return false;
  try{
   for(let current=element;current&&current.nodeType===1;current=current.parentElement){
    const style=win.getComputedStyle(current);
    if(style.display==='none'||style.visibility==='hidden'||style.visibility==='collapse'||Number.parseFloat(style.opacity)===0)return false;
   }
   return true;
  }catch{return true;}
 }
 function createRuntime(win,doc,config){
  const state={phase:'idle',reason:'not-started',locale:config?.locale||'',routeAllowed:false,consentAllowed:false,blocked:true,loaderRequested:false,loaderLoaded:false,reloadRequested:false,unexpectedSdk:false,blockedRequests:0,subscriptionAttempts:0};
  const validConfig=config&&['en','nl'].includes(config.locale)&&typeof config.reviewMode==='boolean';
  let started=false,destroyed=false,featureRequested=false,featureFailed=false,fatal='',script=null,observer=null,restoreFence=null,qaNode=null;
  let closed=new WeakSet();
  const listeners=[];
  const formIds=Array.isArray(config?.formIds)?config.formIds:['SeWdt3','WcVg4s','RLQbrf','Uzqp8N'];
  let qaEnabled=false;
  try{qaEnabled=config?.reviewMode===true&&new URL(win.location.href).searchParams.get('bf_signup_qa')==='1';}catch{}
  const snapshot=()=>({...state});
  function listen(target,name,handler,options){target.addEventListener(name,handler,options);listeners.push(()=>target.removeEventListener(name,handler,options));}
  function attr(node,key,value){if(node?.getAttribute(key)!==value)node?.setAttribute(key,value);}
  function publish(){
   attr(doc.documentElement,'data-bf-signup-blocked',String(state.blocked));
   if(!qaEnabled)return;
   if(!qaNode){qaNode=doc.createElement('output');qaNode.id='bf-signup-runtime-qa';qaNode.setAttribute('aria-live','off');(doc.body||doc.documentElement).appendChild(qaNode);}
   const value=JSON.stringify(snapshot());
   if(qaNode.textContent!==value)qaNode.textContent=value;
   attr(doc.documentElement,'data-bf-signup-phase',state.phase);
   attr(doc.documentElement,'data-bf-signup-reason',state.reason);
  }
  function closeOwned(){
   doc.querySelectorAll(ownedSelector).forEach(dialog=>{
    if(closed.has(dialog))return;
    const close=dialog.querySelector('button[aria-label="Close dialog"]');
    if(close){closed.add(dialog);close.click();}
   });
  }
  function unexpectedSDK(){
   const extra=[...doc.querySelectorAll('script[src]')].some(node=>{
    if(node===script)return false;
    try{const url=new URL(node.getAttribute('src'),win.location.href);return url.hostname==='static.klaviyo.com'&&url.pathname==='/onsite/js/klaviyo.js';}catch{return false;}
   });
   if(extra)return true;
   if(state.loaderRequested)return false;
   try{return typeof win.klaviyo!=='undefined'||typeof win._klOnsite!=='undefined'||typeof win._learnq!=='undefined';}catch{return true;}
  }
  function requestReload(reason){
   if(state.reloadRequested)return;
   state.reloadRequested=true;state.phase='reload-required';state.reason=reason;state.blocked=true;
   publish();
   try{win.location.reload();}catch{state.reason='reload-failed';publish();}
  }
  function ensureFeatures(){
   if(readConsent(win.Shopify?.customerPrivacy).reason!=='consent-api-unavailable'||featureRequested||typeof win.Shopify?.loadFeatures!=='function')return;
   featureRequested=true;
   try{win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(destroyed)return;featureFailed=Boolean(error);evaluate();});}catch{featureFailed=true;}
  }
  function evaluate(){
   if(destroyed)return snapshot();
   if(state.reloadRequested){state.blocked=true;publish();return snapshot();}
   ensureFeatures();
   state.routeAllowed=validConfig&&isRouteAllowed(win.location.pathname,config.locale);
   const consent=readConsent(win.Shopify?.customerPrivacy);
   state.consentAllowed=consent.allowed;
   if(unexpectedSDK()){fatal='unexpected-sdk';state.unexpectedSdk=true;}
   const overlay=[...doc.querySelectorAll(blockerSelector)].some(element=>isElementVisible(win,element));
   state.blocked=!validConfig||!state.routeAllowed||!consent.allowed||overlay||Boolean(fatal)||featureFailed;
   if((state.loaderRequested||state.loaderLoaded)&&!consent.allowed){requestReload(consent.reason);return snapshot();}
   if(state.blocked){
    state.phase=fatal?'error':'blocked';
    state.reason=!validConfig?'invalid-config':fatal||(!state.routeAllowed?'route-excluded':featureFailed?'consent-feature-error':!consent.allowed?consent.reason:'overlay-active');
    closeOwned();publish();return snapshot();
   }
   closed=new WeakSet();
   if(!state.loaderRequested){
    state.loaderRequested=true;state.phase='loading';state.reason='sdk-requested';publish();
    script=doc.createElement('script');script.id='bf-signup-klaviyo-loader';script.async=true;script.src=sdkURL;
    script.setAttribute('data-bf-signup-loader','true');
    script.onload=()=>{if(!destroyed){state.loaderLoaded=true;evaluate();}};
    script.onerror=()=>{if(!destroyed){fatal='sdk-load-error';evaluate();}};
    (doc.head||doc.documentElement).appendChild(script);
   }else{state.phase=state.loaderLoaded?'ready':'loading';state.reason=state.loaderLoaded?'sdk-ready':'sdk-requested';publish();}
   return snapshot();
  }
  function reviewSubmit(event){
   if(config.reviewMode!==true||!event.target?.matches?.('.bf-newsletter'))return;
   event.preventDefault();event.stopImmediatePropagation();
   const status=event.target.querySelector('[role="status"]');
   if(status){
    status.textContent=config.locale==='nl'?'Dit is een ongepubliceerd voorbeeld. Er is niets verstuurd en je gegevens zijn niet opgeslagen.':'This is an unpublished preview. Nothing was sent and your details were not saved.';
    status.hidden=false;status.setAttribute('tabindex','-1');status.dataset.state='review';status.focus({preventScroll:true});
   }
  }
  function start(){
   if(started||destroyed)return snapshot();
   started=true;
   if(config?.reviewMode===true){
    try{restoreFence=installReviewFence(win,subscription=>{state.blockedRequests++;if(subscription)state.subscriptionAttempts++;publish();});}catch{fatal='review-fence-unavailable';}
    listen(doc,'submit',reviewSubmit,true);
   }
   listen(doc,'visitorConsentCollected',evaluate);
   listen(win,'klaviyoForms',event=>{
    if(formIds.includes(event.detail?.formId)){if(event.detail?.type==='open')closed=new WeakSet();evaluate();}
   });
   listen(win,'popstate',evaluate);listen(win,'pageshow',evaluate);listen(win,'load',evaluate);
   if(typeof win.MutationObserver==='function'){
    observer=new win.MutationObserver(evaluate);
    observer.observe(doc.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['style','class','hidden','open','aria-hidden']});
   }else fatal='visibility-observer-unavailable';
   return evaluate();
  }
  function destroy(){
   if(destroyed)return;
   destroyed=true;listeners.splice(0).forEach(remove=>remove());observer?.disconnect();
   if(script){script.onload=null;script.onerror=null;}
   restoreFence?.();qaNode?.remove();
  }
  return {start,evaluate,snapshot,destroy};
 }
 return {normalizeRoute,isRouteAllowed,readConsent,isVendorRequest,installReviewFence,isElementVisible,createRuntime};
});
